import { Component, effect, input, output, viewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions, NgJsonEditorModule } from 'ang-jsoneditor';

@Component({
  selector: 'app-json-viewer',
  templateUrl: './json-viewer.html',
  styleUrl: './json-viewer.scss',
  imports: [NgJsonEditorModule],
  standalone: true,
})
export class JsonViewerComponent {
  readonly data = input.required<object | null>();
  readonly schema = input.required<object>();

  onDataChangeEvent = output<{ jsonData: object | null; isValid: boolean }>();

  readonly editor = viewChild<JsonEditorComponent>('editor');
  public editorOptions: JsonEditorOptions;

  constructor() {
    this.editorOptions = new JsonEditorOptions();
    this.initEditorOptions();
    effect(() => {
      const schema = this.schema();
      if (!schema) return;

      this.editorOptions.schema = schema;
    });
  }

  async onChange() {
    const editorJson = this.editor()?.getEditor();
    if (!editorJson) {
      this.onDataChangeEvent.emit({ jsonData: null, isValid: false });
      return;
    }

    const generalErrors = await editorJson.validate();
    const schemaErrors = editorJson.validateSchema?.errors;

    const hasGeneralErrors = Array.isArray(generalErrors) && generalErrors.length > 0;
    const hasSchemaErrors = Array.isArray(schemaErrors) && schemaErrors.length > 0;

    if (hasGeneralErrors || hasSchemaErrors) {
      this.onDataChangeEvent.emit({ jsonData: null, isValid: false });
    } else {
      const newValue = this.editor()?.get() || null;
      this.onDataChangeEvent.emit({ jsonData: newValue, isValid: true });
    }
  }

  initEditorOptions() {
    this.editorOptions.modes = ['code', 'tree'];
    this.editorOptions.mode = 'code';
    this.editorOptions.enableSort = false;
    this.editorOptions.enableTransform = false;
    this.editorOptions.search = false;
    this.editorOptions.statusBar = false;

    this.editorOptions.onModeChange = (newMode) => {
      if (newMode === 'tree') {
        this.editor()?.getEditor()?.expandAll();
      }
    };

    this.editorOptions.onChangeText = () => {
      void this.onChange();
    };
  }
}
